module.exports = __webpack_public_path__ + "img/three-wen@3x.0211ad61.png";